import './app.js'; // 🎯 Vite leerá esto en desarrollo y unificará app.js dentro del dist final

(async function boot() {
  console.log("🚀 Boot index dashboards_memebrs");
  console.log("✅ Todos los módulos han sido unificados y cargados por Vite");
})();